export const waitForImage = (src: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      if (image.naturalHeight + image.naturalWidth === 0) {
        reject(new Error('wrong image dimensions'));
      }

      resolve(src);
    };
    image.onerror = (e: ErrorEvent) => {
      reject(e);
    };
    image.src = src;
  });
};
